import * as React from 'react';
import { useLocation } from 'wouter';
import { useAccessToken } from '~/AccessToken';
import { LoginRoute } from '~/Application/routes';
import { useSearchParams } from '~/Router';
export var useRequireAccessToken = function () {
    var _a = useAccessToken(), result = _a[0], token = _a[1];
    var location = useLocation()[0];
    var searchParams = useSearchParams();
    var redirectToLogin = LoginRoute.useRedirect();
    var backlink = React.useMemo(function () {
        var query = searchParams.toString();
        return "".concat(location).concat(query !== '' ? "?".concat(query) : '');
    }, [location, searchParams]);
    React.useEffect(function () {
        if (result.isResolved && result.value === null) {
            redirectToLogin({ data: { backlink: backlink }, replace: true });
        }
    }, [result]);
    return [result, token, function () { return <LoginRoute.Redirect replace data={{ backlink: backlink }}/>; }];
};
